import { z } from "zod";

const DeploymentProductSchema = z.object({
  Id: z.string().uuid(),
  Name: z.string(),
  ThumbnailUrl: z.string().optional(),
});

export const DeploymentLicenseItemSchema = z.object({
  Product: DeploymentProductSchema,
  ProductId: z.string().uuid(),
  AvailableCount: z.number().optional(),
  TotalCount: z.number().optional(),
  Assignments: z.array(z.string().uuid()),
});

export type DeploymentLicenseItemType = z.infer<
  typeof DeploymentLicenseItemSchema
>;
